var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-suggested-sample-card-map",attrs:{"id":'Fullscreen' + _vm.sampleNumber}},[_c('div',{staticClass:"analysis-sample-map",attrs:{"id":'SampleMap'+ _vm.sampleNumber}})])
}
var staticRenderFns = []

export { render, staticRenderFns }